import * as Sentry from '@sentry/react';

const EXCLUDE_EMAILS = /^.+@(e2e.test|cast.ai|castai.co)$/i;

const excludeEmail = (email: string): boolean =>
  EXCLUDE_EMAILS.test(email) || !email.includes('@');

type Event =
  | 'demo-booked-console'
  | 'clicked-optimize'
  | 'savings-report'
  | 'installed-agent'
  | 'product-signup'
  | 'ab-phone-completed'
  | 'signup_completed';

export const gtmPushEvent = (
  event: Event,
  params?: Record<string, string>,
  email?: string
): void => {
  try {
    if (email && !excludeEmail(email)) {
      // TODO (Justas - NX migration): Make `window.d.ts` available across libs
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event,
        ...params,
      });
    }
  } catch (error) {
    console.error(error);
    Sentry.captureException(error);
  }
};
